import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { SrOnly } from '../../../../../../utils/accessibility/SrOnly/SrOnly';
import { DayAvailabilityDataHooks } from './constants';
import { classes, st } from './DayAvailability.st.css';

export interface DayAvailabilityProps {
  date: string;
  isDisabled: boolean;
  accessibility: {
    dayWithoutSlotsSrOnlyText: string;
    dayWithSlotsSrOnlyText: string;
  };
  slots?: React.ReactNode;
  noSlots?: React.ReactNode;
}

export const DayAvailability: React.FC<DayAvailabilityProps> = ({
  accessibility: { dayWithSlotsSrOnlyText, dayWithoutSlotsSrOnlyText },
  date,
  isDisabled,
  noSlots,
  slots,
}) => {
  const noSlotsComponent = noSlots ? (
    <>
      <SrOnly
        data-hook={`${DayAvailabilityDataHooks.DayWithoutSlotsSrOnly}-${date}`}
      >
        {dayWithoutSlotsSrOnlyText}
      </SrOnly>
      <Text
        key={`${DayAvailabilityDataHooks.DayWithoutSlots}-${date}`}
        data-hook={`${DayAvailabilityDataHooks.DayWithoutSlots}-${date}`}
        className={st(classes.noSlots, { isDisabled })}
        aria-hidden
      >
        {noSlots}
      </Text>
    </>
  ) : null;

  return (
    <div className={classes.root}>
      {slots ? (
        <>
          <SrOnly
            data-hook={`${DayAvailabilityDataHooks.DayWithSlotsSrOnly}-${date}`}
          >
            {dayWithSlotsSrOnlyText}
          </SrOnly>
          {slots}
        </>
      ) : (
        noSlotsComponent
      )}
    </div>
  );
};
